import { render, staticRenderFns } from "./companyApprovalDetail.vue?vue&type=template&id=e1ecf638&scoped=true&"
import script from "./companyApprovalDetail.vue?vue&type=script&lang=js&"
export * from "./companyApprovalDetail.vue?vue&type=script&lang=js&"
import style0 from "./companyApprovalDetail.vue?vue&type=style&index=0&id=e1ecf638&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ecf638",
  null
  
)

export default component.exports